import React, { useEffect, useState } from 'react';
import Sidebar from '../../components/Sidebar';
import { useLanguage } from '../../contexts/LanguageContext';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export default function AdminContacts() {
  const { t } = useLanguage();
  const [contacts, setContacts] = useState<any[]>([]);

  useEffect(() => {
    axios.get(`${API}/api/admin/contacts`, { withCredentials: true }).then(r => setContacts(r.data)).catch(() => {});
  }, []);

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar type="admin" active="contacts" />
      <main data-testid="admin-contacts-page" style={{ flex: 1, background: 'var(--bg-portal)', padding: 32 }}>
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
          <h1 style={{ fontFamily: 'var(--font-heading)', fontSize: 28, fontWeight: 700, marginBottom: 24 }}>{t('admin.contacts')}</h1>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            {contacts.length === 0 ? (
              <div style={{ background: 'white', border: '1px solid var(--border)', padding: 48, textAlign: 'center', color: 'var(--text-muted)' }}>
                No messages yet
              </div>
            ) : contacts.map(c => (
              <div key={c._id} data-testid={`contact-msg-${c._id}`} style={{ background: 'white', border: '1px solid var(--border)', padding: 24 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
                  <div>
                    <p style={{ fontWeight: 600, fontSize: 15 }}>{c.name}</p>
                    <p style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{c.email}</p>
                  </div>
                  <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>{c.created_at ? new Date(c.created_at).toLocaleDateString() : ''}</span>
                </div>
                {c.subject && <p style={{ fontSize: 14, fontWeight: 600, color: 'var(--text-primary)', marginBottom: 8 }}>{c.subject}</p>}
                <p style={{ fontSize: 14, color: 'var(--text-secondary)', lineHeight: 1.6 }}>{c.message}</p>
              </div>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}
